module.exports = new __parcel__URL__("BricksInMotion.e71e100b.webp").toString();